/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../services/core/local-storage.service';
import {
  LoadingController,
  AlertController,
  ModalController,
} from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { Router } from '@angular/router';
import { ActionSheetController } from '@ionic/angular';
import { UpdatePasswordPage } from '../models/update-password/update-password.page';
import { GlobalVariable } from '../global';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
@Component({
  selector: 'app-setup-profile',
  templateUrl: './setup-profile.page.html',
  styleUrls: ['./setup-profile.page.scss'],
})
export class SetupProfilePage implements OnInit {
  customerData: string;
  LastName: string;
  FirstName: string;
  Email: string;
  Birthday: string;
  Anniversary: string;
  DateJoined: string;
  CustomerType: string;
  ProfileComplete: string;
  PhoneVerified: string;
  Phone: string;
  Password: any;
  BusinessId: string;

  userImage = '';
  isLoading = false;

  imagePickerOptions = {
    maximumImagesCount: 1,
    quality: 50,
  };
  constructor(
    private alertCtrl: AlertController,
    private server: UserApiService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private loadingCtrl: LoadingController,
    // private camera: Camera,
    // private file: File,
    public actionSheetController: ActionSheetController,
    public modalController: ModalController,

    public globals:GlobalVariable,
    public nativeStorage:NativeStorage,

  ) {
   
  }

  ngOnInit() {
    // this.customerData=this.localStorageService.getCustomerData('customerData')
    // console.log('customerdata',this.customerData)
  }
  ionViewWillEnter(){
    console.log('entered Edit Profile')
    this.getCustomerDataFromLocal();
  }

  async customerProfileEdit() {
    if (this.FirstName == '') {
      console.log(
        'FirstName',
        (this.FirstName = this.localStorageService.getFirstName('FirstName'))
      );
    }
    if (this.LastName == '') {
      console.log(
        'LastName',
        (this.LastName = this.localStorageService.getLastName('LastName'))
      );
    }
    if (this.Phone == '') {
      console.log(
        'LastName',
        (this.Phone = this.localStorageService.getLastName('LastName'))
      );
    }
    if (this.Email == '') {
      console.log(
        'LastName',
        (this.Email = this.localStorageService.getLastName('LastName'))
      );
    }
    if(!this.Password || this.Password.length<6){
      this.globals.presentToast('Atleast 6 characters are required for password.')
      return
    }

    const loading = await this.loadingCtrl.create({
      message: 'Updating Profile..',
    });
    await loading.present();

    this.server
      .customerProfileEdit(
        this.FirstName,
        this.Email,
        this.LastName,
        this.Password,
        this.Phone,
        this.Birthday,
        this.Anniversary
      )
      .subscribe(
        async (data) => {
          console.log(data);
          // this.userImage=data.updated_data.image;

          this.localStorageService.setFirstName('FirstName', this.FirstName);
          this.localStorageService.setLastName('LastName', this.LastName);
          this.localStorageService.setEmail('Email', this.Email);
          // this.localStorageService.setBirthday('Birthday', this.Birthday);
          // this.localStorageService.setAnniversary('Anniversary',this.Anniversary);
          // this.localStorageService.setPhone('Phone', this.Phone);

          loading.dismiss();
          if(data.success==true){
            this.nativeStorage.setItem('user',{
              email: data.updated_data.email,
              udid: data.updated_data.udid,
              firstName: data.updated_data.first_name,
              lastName: data.updated_data.last_name,
              phone: data.updated_data.phone,
              // password: password,
              image: data.updated_data.url,
              ID: data.updated_data.id,
              date: data.updated_data.date_joined,
             
              birthday: data.updated_data.birthday,
              aniversary: data.updated_data.anniversary
            }).then(res=>{
              console.log('natve storage login ',res);
            })
            this.globals.presentToast("Profile updated.")
            this.modalController.dismiss({data:{firstname:this.FirstName,lastname:this.LastName,password:this.Password}})
          }
          else{
            this.globals.presentToast("Profile update failed.")

          }
        },
        async (error) => {
          console.log(error);
          const alert = await this.alertCtrl.create({
            header: 'Error',
            message: 'No response from server.Check internet connection.',
            buttons: ['OK'],
          });
          await alert.present();
          loading.dismiss();
        }
      );

    // this.router.navigate[('/setup-profile')];
  }

  getCustomerDataFromLocal() {
    this.FirstName = this.localStorageService.getFirstName('FirstName');
    this.LastName = this.localStorageService.getLastName('LastName');
    this.Email = this.localStorageService.getEmail('Email');
    this.Birthday = this.localStorageService.getBirthday('Birthday');
    this.Anniversary = this.localStorageService.getAnniversary('Anniversary');
    this.DateJoined = this.localStorageService.getDateJoined('DateJoined');
    this.CustomerType =
      this.localStorageService.getCustomerType('CustomerType');
    this.ProfileComplete =
      this.localStorageService.getProfileComplete('ProfileComplete');
    this.PhoneVerified =
      this.localStorageService.getPhoneVerified('PhoneVerified');
    this.Phone = this.localStorageService.getPhone('Phone');
    this.BusinessId = this.localStorageService.getBusinessId('BusinessId');
  }
  async goToUpdatePassword() {
    const modal = await this.modalController.create({
      component: UpdatePasswordPage,
      // cssClass: 'customize_ItemsModel',
    });
    return await modal.present();
  }
  close(){
    this.modalController.dismiss();
  }
}
